import { motion } from 'framer-motion';
import React from 'react';
import useVisibility from '../../Hooks/useVisibility';
import PopUp from '../../SharedComponents/PopUp';
import '../../Styles/Projects/ProjectsPage.css';
import VideoModal from './VideoModal';

const MilaapProject = () => {
    const [videoModal, toggleVideoModal] = useVisibility(false);

    return (
        <div className="flex-box milaap-main-container">
            <motion.div className="flex-box project-item-content-container" initial={{ x: `300%` }} animate={{ x: 0 }} transition={{ duration: 1 }}>
                <h2 className="project-item-title">Milaap</h2>
                <ul className="project-item-points">
                    <li>Milaap is a crowd funding platform, who help to connect people in need and people who want to help for betterment of society.</li>
                    <li>Developed a look alike of it, Focusing on Raising a campaign and Making donations.</li>
                    <li>Done in collaboration with 2 members, In under a week.</li>
                </ul>
                <div className="flex-box projects-page-buttons-container">
                    <div className="projects-page-button project-page-button-left" onClick={() => window.open(`https://github.com/Guru-Eco/milaap-clone`)}>Code</div>
                    <div className="projects-page-button project-page-button-right" onClick={() => window.open(`https://milapp-clone.netlify.app`)}>Demo</div>
                </div>
            </motion.div>
            <motion.div className="flex-box project-item-image-container" initial={{ x: `-300%` }} animate={{ x: 0 }} transition={{ duration: 1 }}>
                <div className="flex-box milaap-logo-background">
                    <img src={process.env.PUBLIC_URL + '/Images/milaapLogo.png'} onClick={toggleVideoModal} alt="milaap" />
                </div>
                <div className="project-video-play-icon flex-box"></div>
                <i className="fa fa-play" aria-hidden="true" onClick={toggleVideoModal}></i>
            </motion.div>
            {
                videoModal && (
                    <div className="video-modal-main-wrapper flex-box">
                        <PopUp className="video-wrapper-container flex-box">
                            <VideoModal url={process.env.PUBLIC_URL + '/Videos/milaap.mp4'} />
                        </PopUp>
                    </div>
                )
            }
        </div>
    )
}

export default MilaapProject
